import React, { useState } from 'react';
import Icon from '../Icon';

const vimeoBaseUrl = "https://player.vimeo.com/video/";
const youtubeBaseUrl = "https://www.youtube.com/embed/";

const ProductMedia = (mediaList) => {
    return (
        <div className='flex flex-col gap-4'>
            {mediaList.internalAttachments && mediaList.internalAttachments.length > 0 && (
                <ProductMediaFile files={mediaList.internalAttachments}></ProductMediaFile>
            )}
            {mediaList.externalAttachments && mediaList.externalAttachments.length > 0 && (
                <ProductMediaVideo videos={mediaList.externalAttachments}></ProductMediaVideo>
            )}
        </div>
    );
};

const ProductMediaFile = (files) => {
    return (
        <>
            {files.files && files.files.map(x => (
                <a key={x.filename} className='bg-gray-50 border-2 border-gray-200 border-solid flex p-3 m-0 items-center gap-2 hover:bg-gray-100 cursor-pointer' href={x.url} target="_blank" download>
                    <Icon name="file" className='flex items-center justify-center' size="lg"/>
                    <span className='flex-grow'>{x.filename}</span>
                    <Icon name="file-arrow-down"  size="lg"/>
                </a>
            ))}
        </>
    );
};

const ProductMediaVideo = (videos) => {
    return (
        <>
        {videos.videos && videos.videos.map(x => (
            <div className='w-full aspect-video' key={x.videoId}>
                {x.videoId && x.source && x.source == "Vimeo" && 
                    <>
                        <iframe className='w-full aspect-video' src={vimeoBaseUrl+x.videoId}></iframe>
                    </>
                }
                {x.videoId && x.source && x.source == "YouTube" && 
                    <>
                        <iframe className='w-full aspect-video' src={youtubeBaseUrl+x.videoId+"?enablejsapi=1"}></iframe>
                    </>
                }
            </div>
        ))}
        </>
    );
};

export default ProductMedia;
